<template lang="html">
  <v-dialog
    persistent
    v-model="active"
    transition="dialog-transition"
    max-width="600px"
  >
    <v-card>
      <v-container pa-0>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title primary-title>
              <h1 v-if="!id" class="headline">New Form Link</h1>
              <h1 v-else class="headline">Edit Form Link</h1>
            </v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text>
              <v-text-field
                label="Title"
                  required
                v-model="formFields.title"
              ></v-text-field>
              <v-text-field
                label="Subtitle"
                  required
                v-model="formFields.subtitle"
              ></v-text-field>
              <v-text-field
                label="Link to form"
                  required
                v-model="formFields.url"
              ></v-text-field>
              <v-text-field
                label="Image URL"
                  required
                v-model="formFields.src"
              ></v-text-field>
            </v-card-text>
            <v-img
              class="mx-3"
              height="150px"
              :src="formFields.src"
            ></v-img>
            <v-divider class="mt-3"></v-divider>
            <v-expansion-panel class="elevation-0">
             <v-expansion-panel-content
             >
               <div slot="header">Advanced...</div>
               <v-card-text class="grey lighten-3">
                 <v-subheader>Advanced settings</v-subheader>
                 <v-btn
                   v-if="id"
                   block depressed
                   color="error"
                   @click="onDelete">
                   Delete<v-icon right>delete</v-icon>
                 </v-btn>
               </v-card-text>
             </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
              <v-btn flat color="primary" @click="onSave">Save</v-btn>
              <v-btn flat color="error" v-on:click="onCancel">Cancel</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {} from 'vuex'
export default {
  data () {
    return {
      dialog: false,
      defaultForm: {
        title: 'My Form',
        subtitle: 'No description provided',
        cta: 'Begin',
        url: 'https://sunpeakpower.com',
        src: 'https://source.unsplash.com/1600x900/?nature,green',
        deleted: false
      }
    }
  },
  computed: {
    formFields () {
      // used for auto fill values
      if (this.id) {
        const form = this.$store.getters['tools/forms/forms'][this.id]
        return form
      } else {
        return {
          // default new form fields
          src: 'https://source.unsplash.com/1600x900/?nature,green' // random image
        }
      }
    }
  },
  methods: {
    onCancel () {
      this.$emit('dialog-state', false)
    },
    onSave () {
      const form = {
        ...this.defaultForm,
        ...this.formFields
      }
      this.$emit('dialog-state', false)
      if (this.id) {
        this.$store.dispatch('tools/forms/updateForm', form)
      } else {
        this.$store.dispatch('tools/forms/newForm', form)
      }
    },
    onDelete () {
      this.$emit('dialog-state', false)
      this.$store.dispatch('tools/forms/deleteForm', this.id)
    }
  },
  props: [
    'id',
    'active'
  ]
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Tools/Forms/FormEditDialog.vue